import request from '@/utils/seftRequest';
import baseRequest from '@/utils/request';


// 查询代理商绑定订户统计信息接口 drm/ding/channel/qryOrgBindSubsSummary
export function qryOrgBindSubsSummary(data) {
  return request(`/ding/channel/qryOrgBindSubsSummary?orgId=${data.orgId}`);
}
// export function qryOrgBindSubsSummary(data) {
//   return request('/ding/channel/qryOrgBindSubsSummary', {
//     method: 'POST',
//     body: data,
//   });
// }
// 查询子节点下拉数据 drm/ding/common/qryRegionList
export function qryRegionList(data) {
  return request('/ding/common/qryRegionList', {
    method: 'GET',
    params: data,
  });
}

// 查询代理商绑定订户列表接口 drm/ding/channel/qryOrgBindSubsList
export function qryOrgBindSubsList(data) {
  return request('/ding/channel/qryOrgBindSubsList', {
    method: 'POST',
    body: data,
  });
}

// 查询组织员工列表接口 /drm/ding/channel/queryOrgStaffList
export function queryOrgStaffList(data) {
  return request(`/ding/channel/queryOrgStaffList?orgId=${data.orgId}`);
}

export function queryStaffList(data) {
  return baseRequest('/drm/selfserv/staffs', {
    method: 'POST',
    body: data,
  });
}
// 代理商绑定订户指定到员工 drm/ding/channel/orgbindSubsAssign
export function orgbindSubsAssign(data) {
  return request('/ding/channel/orgbindSubsAssign', {
    method: 'POST',
    body: data,
  });
}
